import { WorkCard } from "./WorkCard";
import type { Work } from "@/pages/Works";

interface WorksGridProps {
  works: Work[];
  viewMode: "grid" | "list";
}

export const WorksGrid = ({ works, viewMode }: WorksGridProps) => {
  if (works.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="text-muted-foreground text-lg">
          Nenhuma obra encontrada
        </div>
        <p className="text-sm text-muted-foreground mt-2">
          Tente ajustar os filtros ou termo de busca
        </p>
      </div>
    );
  }

  return (
    <div className={viewMode === "list" ? "space-y-2" : "grid grid-cols-1 lg:grid-cols-2 gap-4"}>
      {works.map((work) => (
        <WorkCard key={work.id} work={work} viewMode={viewMode} />
      ))}
    </div>
  );
};